var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6734_76410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2008 10.0008C19.2008 12.4408 18.2315 14.7808 16.5062 16.5062C14.7808 18.2315 12.4408 19.2008 10.0008 19.2008C7.56079 19.2008 5.22073 18.2315 3.4954 16.5062C1.77006 14.7808 0.800781 12.4408 0.800781 10.0008C0.800781 7.56079 1.77006 5.22073 3.4954 3.4954C5.22073 1.77006 7.56079 0.800781 10.0008 0.800781C12.4408 0.800781 14.7808 1.77006 16.5062 3.4954C18.2315 5.22073 19.2008 7.56079 19.2008 10.0008ZM14.6353 6.51628C14.5531 6.43442 14.4553 6.36997 14.3477 6.32678C14.2401 6.28359 14.1248 6.26254 14.0089 6.26491C13.893 6.26727 13.7787 6.29299 13.6729 6.34053C13.5671 6.38806 13.472 6.45645 13.3933 6.54158L9.39933 11.6303L6.99238 9.22223C6.82888 9.06988 6.61263 8.98694 6.38918 8.99088C6.16574 8.99482 5.95254 9.08534 5.79452 9.24337C5.63649 9.40139 5.54597 9.61459 5.54203 9.83803C5.53809 10.0615 5.62103 10.2777 5.77338 10.4412L8.81628 13.4853C8.89826 13.5671 8.99587 13.6316 9.1033 13.6749C9.21074 13.7181 9.32579 13.7393 9.44159 13.7372C9.55739 13.7351 9.67158 13.7096 9.77733 13.6624C9.88309 13.6151 9.97825 13.5471 10.0571 13.4623L14.6479 7.72378C14.8044 7.56106 14.8909 7.34345 14.8888 7.11768C14.8866 6.89192 14.796 6.676 14.6364 6.51628H14.6353Z",
    fill: "#2C9424"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6734_76410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/check-circle-icon.62eeff51edbf936313c0f31b72a4ee22.svg";
export { ForwardRef as ReactComponent };